import React, { useState } from "react";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { IoCloudUploadOutline } from "react-icons/io5";
import { BsFolder, BsFolderPlus } from "react-icons/bs";
import { CiFolderOn } from "react-icons/ci";
import { MdOutlineSubdirectoryArrowRight } from "react-icons/md";

const NewFolderModal = ({ show, handleClose, fetchCloud, project_id, folder_path }) => {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const user_id = sessionStorage.getItem("user_id");
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [folderName, setFolderName] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState({ message: "", display: false })

    const CloseModal = () => {
        setSelectedFiles([]);
        handleClose();
        setError({ message: "", display: false });
    }

    const SaveFolder = async () => {
        setLoading(true)
        setError({ message: "", display: false })


        let dataToSend = {
            user_id: user_id,
            project_id: project_id,
            folder_path: folder_path,
            folder_name: folderName,
        }
        try {
            const response = await fetch('http://127.0.0.1:5000/create_folder', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend),
            });
            setLoading(false)
            if (response.ok) {
                CloseModal()
                fetchCloud()
            } else {
                setError({ message: t.err_save_general, display: true })
            }
        } catch (error) {
            setLoading(false)
            setError({ message: t.err_save_general, display: true })
        }


    }



    return (
        <Modal show={show} onHide={handleClose} className="modal_edit">
            <div className="modal_header">
                <p className="share_label"><i><BsFolderPlus /></i> Create a new folder</p>
            </div>
            <div className="modal_body">
                <div className="label_input_section">
                    <label>Folder name</label>
                    <input
                        className="description_area_input"
                        placeholder="New folder"
                        value={folderName}
                        onChange={(e) => setFolderName(e.target.value)}
                    />
                </div>
                <div className="choose_folder">
                    <p><MdOutlineSubdirectoryArrowRight /> {folder_path} / <strong>{folderName}</strong></p>
                </div>
            </div>
            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button
                        className="save_btn"
                        onClick={SaveFolder}
                        // disabled={!selectedFiles.length}
                    >
                        {loading ? <Spinner loading={loading} /> : <>{t.save}</>}
                    </button>
                    <button className="cancel_btn" onClick={CloseModal}>{t.cancel}</button>
                </div>
            </div>
        </Modal>
    );
};

export default NewFolderModal;
